
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth,apikey } from '../../constants/api';
import {
    MENU_FETCH,
} from '../actions';

import {
    menuSuccess,
    menuFail,
} from './actions';

const menuFetchAsync = async (data) =>
	 await API.post('/user/menulist', {
		userId: data,
	 } ,
	 {
      headers : {
        'Content-Type': 'application/json',
        'apikey': '87cdf9229caf9a7fa3fd1403bcc5dd97'
      }
    })
        .then(data => data)
        .catch(error => error);



//* Get Device List
function* menuFetch({ payload }) {

    try {
		 const{ menulist } = payload;
		  const menuFetch = yield call(menuFetchAsync , menulist);

        if (menuFetch.data.StatusCode === "0000") {
            yield put(menuSuccess(menuFetch.data.ResultValues));
        } else {
            yield put(menuFail(menuFetch.data.Message));
        }
    } catch (error) {
        yield put(menuFail(error));
    }
}



export function* watchMenuFetch() {
    yield takeEvery(MENU_FETCH, menuFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchMenuFetch),
    ]);
}
